const BASE_DOMAIN = process.env.REACT_APP_BASE_DOMAIN || "localhost:3000";

export const getTenantUrl = (refererKey?: string, path: string = "") => {
  if (!refererKey) return "#";

  return `http://${refererKey}.${BASE_DOMAIN}${path}`;
};

export const getDomainSlug = () => {
  const hostname = window.location.hostname.toLowerCase();
  const baseDomain = (process.env.REACT_APP_BASE_DOMAIN ?? "").toLowerCase();

  if (baseDomain && hostname === baseDomain) {
    return null;
  }

  if (baseDomain && hostname.endsWith("." + baseDomain)) {
    const slug = hostname.replace("." + baseDomain, "");
    return slug.split(".")[0];
  }

  const parts = hostname.split(".");

  if (parts.length > 1 && parts[0] !== "localhost") {
    return parts[0];
  }

  return null;
};
